
import { RangerFirearmAssignmentLogEntityDecorator } from './ranger-firearm-assignment-log.decorator';
import { RangerFirearmAssignmentLog } from './ranger-firearm-assignment-log.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class RangerFirearmAssignmentLogTypeInfoBase implements CrudTypeInfo<RangerFirearmAssignmentLog, number> {
  name = 'Ranger Firearm Assignment Log';
  entityDecorator = new RangerFirearmAssignmentLogEntityDecorator();
  
  createAuthorities = ['WRITE_RANGER_FIREARM_ASSIGNMENT_LOG'];
  editAuthorities = ['WRITE_RANGER_FIREARM_ASSIGNMENT_LOG'];
  deleteAuthorities = ['WRITE_RANGER_FIREARM_ASSIGNMENT_LOG'];
  viewAuthorities = ['READ_FIREARM_ASSIGNMENT'];
  
  searchRouteBase = ['/rangerfirearmassignmentlog/search'];
  createRouteBase = ['/rangerfirearmassignmentlog/create'];
  editRouteBase = ['/rangerfirearmassignmentlog/edit'];
  viewRouteBase = ['/rangerfirearmassignmentlog/view'];
  
  description(item: RangerFirearmAssignmentLog): string {
    return '' +  item.rangerId;
  }
}



